export enum DonationType {
    EVENT_ALM = "EVENT_ALM",
    MORNING_ALM = "MORNING_ALM",
    NOON_ALM = "NOON_ALM",
    FULL_DAY_ALM = "FULL_DAY_ALM",
    DISCRETIONARY_MONEY = "DISCRETIONARY_MONEY",
    BOHI_ETERNAL_TREE = "BOHI_ETERNAL_TREE",
    ALM_BOHI_ETERNAL_TREE = "ALM",
    ELECTRICITY_BOHI_ETERNAL_TREE = "ELECTRICITY",
    PHARMACY_BOHI_ETERNAL_TREE = "PHARMACY",
}

export const DonationTypeLabel = {
    [DonationType.EVENT_ALM]: "ဆွမ်း",
    [DonationType.MORNING_ALM]: "အရုဏ်ဆွမ်း",
    [DonationType.NOON_ALM]: "နေ့ဆွမ်း",
    [DonationType.FULL_DAY_ALM]: "တစ်နေ့လုံးဆွမ်း",
    [DonationType.DISCRETIONARY_MONEY]: "အလှူငွေ",
    [DonationType.BOHI_ETERNAL_TREE]: "ပဒေသာပင်",
    [DonationType.ALM_BOHI_ETERNAL_TREE]: "ပဒေသာပင် (ဆွမ်း)",
    [DonationType.ELECTRICITY_BOHI_ETERNAL_TREE]: "ပဒေသာပင် (လျှပ်စစ်မီး)",
    [DonationType.PHARMACY_BOHI_ETERNAL_TREE]: "ပဒေသာပင် (ဆေးဝါး)",
}


export enum DonationStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    CANCELLED = "CANCELLED",
}